module.exports = __webpack_public_path__ + "static/media/cnhError.b1fdd124.jpg";